import { useContext } from 'react';
import { PortersContext } from './PortersContext';
import { PortersContextType } from './types';

export const usePortersContext = (): PortersContextType => {
  const context = useContext(PortersContext);
  if (!context) {
    throw new Error('usePortersContext must be used within a PortersProvider');
  }
  return context;
};
